<template>
  <div class="ml-3 pt-3" style="overflow-x: hidden">
    <dl class="row my-0" v-for="line in lines">
        <dt class="col-md-2 font-custom">{{line.key}}:</dt>
        <dl class="col font-custom text-nowrap">{{line.value}}</dl>
      </dl>
    <div class="font-display font-weight-bold my-2">Контактные данные</div>
    <dl class="row my-0" v-for="line in contacts">
      <dt class="col-md-2 font-custom">{{line.key}}:</dt>
      <dl class="col font-custom text-nowrap">{{line.value}}</dl>
    </dl>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        lines: [
          {
            key: 'Наименование организации',
            value: 'ООО "ИНТЕЛЛЕКТ ВЕНДИНГ"',
          },
          {
            key: 'ИНН',
            value: '3906298960',
          },
          {
            key: 'КПП',
            value: '390601001',
          },
          {
            key: 'ОГРН',
            value: '1133926025640',
          },
          {
            key: 'ОКПО',
            value: '27773825',
          },
          {
            key: 'Расчетный счет',
            value: '40702810300000019959',
          },
          {
            key: 'Банк',
            value: 'КБ "ЭНЕРГОТРАНСБАНК" (АО)',
          },
          {
            key: 'БИК',
            value: '042748701',
          },
          {
            key: 'Корр. счет',
            value: '30101810800000000701',
          },
        ],
        contacts: [
          {
            key: 'Электронная почта',
            value: 'support@vendoscope.ru',
          },
          {
            key: 'Юридический/почтовый адрес',
            value: '236016, Калининградская обл, Калининград г, Маршала Василевского пл, дом № 2, корпус V-I, оф.19',
          },
        ],
      }
    },
  }
</script>

<style lang="scss">
  .font-custom {
    font-size: 1.2em;
  }
  .font-display {
    font-size: 1.7em;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/admin/info/contacts.vue